import React from 'react';
import { minToTime } from '../../lib/barberSchedule/helpers';

/**
 * Day-view availability grid — the SAME renderer used both inside the
 * modal (week/month clicks) and inline (day view).
 *
 * The `context` prop distinguishes the two mount points: the modal
 * keeps a "Close" button in the actions bar; inline omits it because
 * there's nothing to close.
 */
export const AvailabilityGrid = ({
  dayView, dayViewSlots,
  slotStateFor, toggleSlot,
  onRemoveBreak,
}) => (
  <>
    <div className="dv-legend">
      <span className="lg free">Available</span>
      <span className="lg booked">Booked</span>
      <span className="lg brk">Break</span>
      <span className="lg sel">Selected</span>
    </div>

    <div className="dv-grid" data-testid="dv-grid">
      {dayViewSlots.map((t) => {
        const st = slotStateFor(t);
        const isSel = dayView.selected.has(t);
        const label = minToTime(t);
        const disabled = st === 'booked' || st === 'break';
        return (
          <button
            key={t}
            type="button"
            className={`dv-slot ${st} ${isSel ? 'selected' : ''}`}
            disabled={disabled}
            onClick={() => !disabled && toggleSlot(t)}
            data-testid={`dv-slot-${label}`}
          >
            {label}
          </button>
        );
      })}
    </div>

    {dayView.breaks.length > 0 && (
      <div className="dv-breaks">
        <div className="dv-h">Current breaks</div>
        {dayView.breaks.map((br) => (
          <div key={br.id} className="dv-break-row">
            <span>{br.start_time.slice(0, 5)} – {br.end_time.slice(0, 5)}</span>
            <button className="btn s danger" onClick={() => onRemoveBreak(br.id)} data-testid={`dv-brk-rm-${br.id}`}>Remove</button>
          </div>
        ))}
      </div>
    )}
  </>
);

export const AvailabilityActions = ({
  context, // 'modal' | 'inline'
  dayView, weeklyOpenOnDay,
  onBlockDay, onSaveBreaks, onClose,
}) => (
  <div className="modal-actions dv-actions">
    <button className="btn s danger" onClick={onBlockDay} data-testid="dv-block-day">
      {weeklyOpenOnDay ? 'Block this whole day' : 'Remove force-open'}
    </button>
    <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
      {context === 'modal' && <button className="btn s" onClick={onClose}>Close</button>}
      <button
        className="btn p"
        onClick={onSaveBreaks}
        disabled={dayView.selected.size === 0}
        data-testid="dv-save-breaks"
      >
        Mark selected as break ({dayView.selected.size})
      </button>
    </div>
  </div>
);
